import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProtestoChequeService } from 'src/app/services/protesto-cheque.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAddEditProtestoComponent } from '../modal-add-edit-protesto/modal-add-edit-protesto.component';
import * as _ from 'lodash'
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-cheques-protesto-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss'],
  providers: [SecurityService],
})
export class DetallesComponent implements OnInit {

  @ViewChild('alert', { static: true }) alert: ElementRef;
  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }

  // Modales
  @ViewChild(ModalAddEditProtestoComponent, { static: true }) modalProtesto: ModalAddEditProtestoComponent

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  loadAll: boolean = false
  listaProtestos: any = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private protestoChequeService: ProtestoChequeService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
  }

  loadData({ rutCliente, fechaDesde, fechaHasta }) {
    this.listaProtestos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: rutCliente === null ? 0 : this.rutService.QuitarDV(rutCliente),
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = false
    this.buscar()
  }

  loadAllData() {
    this.listaProtestos = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = true
    this.buscar()
  }

  buscar() {
    this.inputParams.paginaActual = this.paginationContext.CurrentPage

    if (this.loadAll) {
      this.protestoChequeService.obtenerTodosProtesto(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.renderResults(respuesta)
      })
    } else {
      this.protestoChequeService.obtenerSegunFiltro(this.inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.renderResults(respuesta)
      })
    }
  }

  renderResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaProtestos = registros
    this.listaProtestos.map(item => {
      item.cliente_proveedor_rutFormato = this.rutService.AgregarDV(item.cliente_proveedor_rut)
    })
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  openModalProtesto() {
    this.modalProtesto.show()
  }

  loadModalProtesto(codigo) {
    this.modalProtesto.loadAndShow(codigo)
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.inputParams)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    this.protestoChequeService.obtenerExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }

}
